module.exports = __webpack_public_path__ + "img/rightJ.3cc0485e.svg";